module.exports = __webpack_public_path__ + "img/03.d53321f6.jpg";